import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "clip-path": "url(#group_size_2-8e8381__a)"
    }, [
      _createElementVNode("path", { d: "M6.5 6.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM11.75 13.5a5.25 5.25 0 1 0-10.5 0v2.25H3.5l.75 7.5h4.5l.75-7.5h2.25V13.5ZM18.5 6.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM14 15.75h1.5l.75 7.5h4.5l.75-7.5h2.25V13.5A5.25 5.25 0 0 0 14 10.8" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "group_size_2-8e8381__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.5 0h24v24H.5z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }